const messageHandle = {
    path: 'handle-message',
    component: resolve => require(['@/pages/admin/message/add-message.vue'], resolve)
}

export default messageHandle